export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        members: action.members,
      };

    case 'UPDATE':
      return {
        ...state,
        members: state.members.map(
          (item) => (item.id === action.member.id ? action.member : item),
        ),
      };

    case 'DELETE':
      return {
        ...state,
        members: state.members.filter(
          (item) => item.id !== action.memberId.toString(),
        ),
      };

    case 'MULTI_DESTROY':
      return {
        ...state,
        members: state.members.filter(
          (item) => !action.memberIds.includes(item.id),
        ),
      };

    case 'FINCH_UPDATE':
      return {
        ...state,
        finchOptions: {
          ...state.finchOptions,
          ...action.params,
        },
      };

    case 'SET_FILE_NAME':
      return {
        ...state,
        fileName: action.fileName,
      };

    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
